import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MessageInput from './MessageInput';
import MessageBubble from './MessageBubble';
import { FaBars, FaUser, FaUserPlus, FaCheck, FaTimes } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import './ChatWindow.scss';
import fnc from '../../mymod/commFunction';
import { normalizeAcaCode, normalizeChatUserId } from '../../mymod/normalizeAcaCode';
//이것의 부모는? src/page_firebase/ChatWindowPage.js
const ChatWindow = ({ 
  chatroom, 
  messages, 
  currentUser, 
  userProfile,
  onSendMessage,
  onAddParticipants,
  messagesEndRef,
  onGoBack 
}) => {
  const navigate = useNavigate();
  const chatContainerRef = useRef(null);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [participantNames, setParticipantNames] = useState([]);
  
  // Redux에서 사용자 정보 가져오기
  const userInfo = useSelector((state) => state.reduxStore.userInfo);
  const userInfo2 = useSelector((state) => state.reduxStore.userInfo2);
  
  // 현재 로그인한 실제 사용자 ID
  const currentAcaCode = normalizeAcaCode(userInfo2?.acaCode || userInfo?.acaCode);
  const currentUserId = normalizeChatUserId(userInfo2?.id || userInfo?.id || currentUser?.id || currentUser?.uid, currentAcaCode);
  const unreadParticipantCount = useMemo(() => {
    const unreadCount = chatroom?.unreadCount || {};
    const currentUserIds = new Set([
      currentUserId,
      currentUser?.id,
      currentUser?.uid
    ].filter(Boolean));

    return (chatroom?.participants || []).filter((participantId) => (
      !currentUserIds.has(participantId) &&
      Number(unreadCount[participantId] || 0) > 0
    )).length;
  }, [chatroom?.participants, chatroom?.unreadCount, currentUserId, currentUser?.id, currentUser?.uid]);

  const normalizeDisplayId = useCallback((rawId) => {
    if (typeof rawId !== 'string') {
      return '';
    }

    const trimmed = rawId.trim();
    if (!trimmed) {
      return '';
    }

    const tokens = trimmed.split('_');
    if (tokens.length >= 2 && /^(?:[A-Za-z]+\d+|\d+)$/.test(tokens[0])) {
      return tokens.slice(1).join('_');
    }

    return trimmed;
  }, []);

  // 메시지가 업데이트될 때 스크롤 위치 관리
  useEffect(() => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;
      
      if (isNearBottom) {
        scrollToBottom();
      }
    }
  }, [messages]);

  // // 사용자 목록 로드
  // const loadUsers = () => {
  //   fnc.sendAxios('/socialLoginRoutes/select/allUsers', {}, (res) => {
  //     if (res && Array.isArray(res)) {
  //       // 이미 채팅방에 참여 중인 사용자 제외
  //       const currentParticipants = chatroom?.participants || [];
  //       const availableUsers = res.filter(user => !currentParticipants.includes(user.id));
  //       setUsers(availableUsers);
  //     }
  //   });
  // };

  
  // 사용자 목록 로드
  const loadUsers = () => {
    fnc.sendAxios('/socialLoginRoutes/select/allUsers2', { acaCode: currentAcaCode }, (res) => {
      if (res && Array.isArray(res)) {
        const normalizedUsers = res.map((user) => ({
          ...user,
          acaCode: normalizeAcaCode(user.acaCode || currentAcaCode),
          id: normalizeChatUserId(user.id, user.acaCode || currentAcaCode)
        }));
        // 이미 채팅방에 참여 중인 사용자 제외
        const currentParticipants = chatroom?.participants || [];
        const availableUsers = normalizedUsers.filter(user => !currentParticipants.includes(user.id));
        setUsers(availableUsers);
      }
    });
  };

  const loadParticipantNames = useCallback(() => {
    const currentParticipants = chatroom?.participants || [];
    const participantIds = currentParticipants.filter((participantId) => participantId !== currentUserId);

    if (!participantIds.length) {
      setParticipantNames([]);
      return;
    }

    const fallbackNames = participantIds.map((participantId) => normalizeDisplayId(participantId)).filter(Boolean);

    fnc.sendAxios('/socialLoginRoutes/select/allUsers2', { acaCode: currentAcaCode }, (res) => {
      if (!Array.isArray(res)) {
        setParticipantNames(fallbackNames);
        return;
      }

      const participantNameMap = new Map(
        participantIds.map((participantId) => [participantId, normalizeDisplayId(participantId)])
      );

      res.forEach((user) => {
        const displayName = user?.nickname || user?.name || user?.id2 || normalizeDisplayId(user?.id);
        if (!displayName) {
          return;
        }

        if (user?.id && participantNameMap.has(user.id)) {
          participantNameMap.set(user.id, displayName);
        }

        const normalizedUserId = normalizeChatUserId(user?.id, user?.acaCode || currentAcaCode);
        if (normalizedUserId && participantNameMap.has(normalizedUserId)) {
          participantNameMap.set(normalizedUserId, displayName);
        }

        if (user?.id2 && participantNameMap.has(user.id2)) {
          participantNameMap.set(user.id2, displayName);
        }
      });

      const names = participantIds
        .map((participantId) => participantNameMap.get(participantId) || normalizeDisplayId(participantId))
        .filter(Boolean);

      setParticipantNames(names.length ? names : fallbackNames);
    });
  }, [chatroom?.participants, currentAcaCode, currentUserId, normalizeDisplayId]);


  // 모달 열 때 사용자 목록 로드
  // useEffect(() => {
  //   if (showAddUserModal) {
  //     loadUsers();
  //   }
  // }, [showAddUserModal, chatroom?.participants]);

  useEffect(() => {
    if (showAddUserModal) {
      loadUsers();
    }
  }, [showAddUserModal]);

  useEffect(() => {
    loadParticipantNames();
  }, [loadParticipantNames]);

  // 사용자 선택/해제
  const toggleUserSelection = (userId) => {
    setSelectedUsers(prev => 
      prev.includes(userId) 
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  // 검색 필터링
  const filteredUsers = users.filter(user => 
    !searchKeyword || 
    user.nickname?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
    user.id?.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  // 참여자 추가 처리
  const handleAddParticipants = async () => {
    if (selectedUsers.length > 0 && onAddParticipants) {
      console.log('참여자 추가 시작:', selectedUsers);
      console.log('채팅방 ID:', chatroom?.id);
      
      try {
        await onAddParticipants(selectedUsers, chatroom?.id);
        console.log('참여자 추가 완료');
        setSelectedUsers([]);
        setSearchKeyword('');
        setShowAddUserModal(false);
      } catch (error) {
        console.error('참여자 추가 실패:', error);
        alert('참여자 추가에 실패했습니다.');
      }
    }
  };

  // 메시지 소유권 확인 - 실제 사용자 ID 기반 (useCallback으로 최적화)
  const isOwnMessage = useCallback((senderId) => {
    return senderId === currentUserId || senderId === currentUser?.id;
  }, [currentUserId, currentUser?.id]);

  // 사용자 이름 가져오기 (useCallback으로 최적화)
  const getUserDisplayName = useCallback((senderId, originalSenderName) => {
    if (isOwnMessage(senderId)) {
      return userProfile?.nickname || userProfile?.name || originalSenderName || '나';
    }
    return originalSenderName || '익명';
  }, [isOwnMessage, userProfile?.nickname, userProfile?.name]);

  const scrollToBottom = useCallback(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messagesEndRef]);

  // 날짜별로 메시지 그룹화 (useCallback으로 최적화)
  const groupMessagesByDate = useCallback((messages) => {
    const groups = {};
    
    messages.forEach(message => {
      const messageDate = message.timestamp?.toDate ? 
        message.timestamp.toDate() : 
        new Date(message.timestamp);
      
      const dateKey = messageDate.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      });
      
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(message);
    });
    
    return groups;
  }, []);

  // 연속된 같은 사용자 메시지 그룹화 (useCallback으로 최적화)
  const groupConsecutiveMessages = useCallback((messages) => {
    const groups = [];
    let currentGroup = null;
    
    messages.forEach(message => {
      if (!currentGroup || currentGroup.senderId !== message.senderId) {
        if (currentGroup) {
          groups.push(currentGroup);
        }
        currentGroup = {
          senderId: message.senderId,
          senderName: message.senderName,
          messages: [message],
          timestamp: message.timestamp
        };
      } else {
        currentGroup.messages.push(message);
      }
    });
    
    if (currentGroup) {
      groups.push(currentGroup);
    }
    
    return groups;
  }, []);

  // useMemo로 메시지 그룹화 최적화
  const messageGroups = useMemo(() => groupMessagesByDate(messages), [messages, groupMessagesByDate]);

  return (
    <div className="chat-window">
      {/* 채팅방 헤더 */}
      <div className="chat-header">
        <div className="chat-header-info">
          <div className="chatroom-avatar">
            <div className="avatar-circle">
              {chatroom.name.charAt(0).toUpperCase()}
            </div>
          </div>
          <div className="chatroom-details">
            <h4>{chatroom.name}</h4>
            <p className="participant-count">
              <FaUser size={10} />
              <span className="participant-total">{chatroom.participants?.length || 0}</span>
              <span className="participant-names">
                {participantNames.length > 0 ? participantNames.join(', ') : '참여자 없음'}
              </span>
            </p>
          </div>
        </div>
        
        <div className="chat-header-actions">
          <button 
            className="header-action-btn add-participant-btn"
            onClick={() => setShowAddUserModal(true)}
            title="참여자 추가"
          >
            <FaUserPlus size={16} />
          </button>

          <button className="close-btn" onClick={() => navigate('/talk')} title="닫기">
            <AiOutlineClose size={16} />
          </button>
        </div>
      </div>

      {/* 메시지 영역 */}
      <div className="chat-messages" ref={chatContainerRef}>
        {Object.keys(messageGroups).length === 0 ? (
          <div className="no-messages">
            <p>아직 메시지가 없습니다.</p>
            <p>첫 번째 메시지를 보내보세요! 👋</p>
          </div>
        ) : (
          Object.entries(messageGroups).map(([date, dateMessages]) => (
            <div key={date} className="message-date-group">
              <div className="date-separator">
                <span>{date}</span>
              </div>
              
              {groupConsecutiveMessages(dateMessages).map((group, groupIndex) => {
                const isOwn = isOwnMessage(group.senderId);
                
                return (
                <div 
                  key={`${date}-${groupIndex}`} 
                  className={`message-group ${isOwn ? 'own-message' : 'other-message'}`}
                >
                  {/* 다른 사용자 메시지인 경우 프로필 정보 표시 */}
                  {!isOwn && (
                    <div className="message-sender">
                      <div className="sender-avatar">
                        {getUserDisplayName(group.senderId, group.senderName)?.charAt(0).toUpperCase() || '?'}
                      </div>
                      <span className="sender-name">
                        {getUserDisplayName(group.senderId, group.senderName)}
                      </span>
                    </div>
                  )}
                  
                  {/* 메시지 버블들 */}
                  <div className="message-bubbles">
                    {group.messages.map((message, index) => (
                      <MessageBubble
                        key={message.id}
                        message={message}
                        isOwn={isOwn}
                        showTime={index === group.messages.length - 1}
                        unreadParticipantCount={unreadParticipantCount}
                      />
                    ))}
                  </div>
                </div>
                );
              })}
            </div>
          ))
        )}
        
        <div ref={messagesEndRef} />
      </div>

      {/* 메시지 입력 영역 */}
      <MessageInput 
        onSendMessage={onSendMessage}
      />

      {/* 참여자 추가 모달 */}
      {showAddUserModal && (
        <div className="modal-overlay" onClick={() => setShowAddUserModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>참여자 추가2</h3>
              <button 
                className="modal-close-btn" 
                onClick={() => setShowAddUserModal(false)}
              >
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <input
                type="text"
                placeholder="사용자 검색..."
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="search-input"
              />

              <div className="selected-count">
                {selectedUsers.length}명 선택됨
              </div>

              <div className="users-list">
                {filteredUsers.length === 0 ? (
                  <p className="no-users">
                    {users.length === 0 ? '추가할 수 있는 사용자가 없습니다.' : '검색 결과가 없습니다.'}
                  </p>
                ) : (
                  filteredUsers.map((user, index) => (
                    <div
                      key={user.id}
                      className={`user-item ${selectedUsers.includes(user.id) ? 'selected' : ''}`}
                      onClick={() => toggleUserSelection(user.id)}
                    >
                    
                      <div className="user-info">
                        <span className="user-no">{index + 1}</span>
                        <span className="user-nickname">{user.nickname}</span>
                        <span className="user-id">( {user.id2} )</span>
                      </div>
                      {selectedUsers.includes(user.id) && (
                        <FaCheck className="check-icon" />
                      )}
                    </div>
                  ))
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button 
                className="cancel-btn" 
                onClick={() => {
                  setShowAddUserModal(false);
                  setSelectedUsers([]);
                  setSearchKeyword('');
                }}
              >
                취소
              </button>
              <button 
                className="confirm-btn" 
                onClick={handleAddParticipants}
                disabled={selectedUsers.length === 0}
              >
                추가 ({selectedUsers.length})
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWindow;
